import { Box } from "@repo/components/src/ui/box";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import React from "react";
import DeliverableCard from "./DeliverableCard";
import type { PostTypeInfo } from "./postTypeLookup";
import SectionHeader from "./SectionHeader";
import type { SectionStatus } from "./sectionStatus";
import type { DraftPreviewModel } from "../draftPreviewTypes";

type Props = {
  contents: DraftPreviewModel["contents"];
  postTypes: Map<string, PostTypeInfo>;
  status: SectionStatus;
};

/** Ported from `apps/mobil/.../deliverables/DeliverablesCard.tsx`. */
const DeliverablesSection = React.memo(
  ({ contents, postTypes, status }: Props) => (
    <>
      <SectionHeader title="Entregables" status={status} />
      {contents.length === 0 ? (
        <Box className="rounded-3xl bg-white border border-outline-100 px-4 py-4">
          <Text size="sm" action="muted">
            Aún no hay contenidos definidos.
          </Text>
        </Box>
      ) : (
        <VStack space="sm">
          {contents.map((content, index) => (
            <DeliverableCard
              key={`${content.postTypeId ?? content.label}-${index}`}
              content={content}
              postType={
                content.postTypeId
                  ? postTypes.get(content.postTypeId)
                  : undefined
              }
              index={index + 1}
            />
          ))}
        </VStack>
      )}
    </>
  ),
);

DeliverablesSection.displayName = "DeliverablesSection";

export default DeliverablesSection;
